<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Especialidade"
              rules="required"
            >
              <b-form-group
                label="Especialidade"
                label-for="v-especialidade"
              >
                <v-select
                  v-model="form.especialidade.id"
                  :reduce="(comboEspecialidades) => comboEspecialidades.id"
                  label="nome"
                  :options="comboEspecialidades"
                  :state="errors.length > 0 ? false : null"
                  data-cy="especialidade-select"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-especialidade-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Grupo"
              rules="required"
            >
              <b-form-group
                label="Grupo"
                label-for="v-grupo"
              >
                <v-select
                  v-model="form.grupo.id"
                  :reduce="(comboGrupos) => comboGrupos.id"
                  label="nome"
                  :options="comboGrupos"
                  :state="errors.length > 0 ? false : null"
                  data-cy="grupo-select"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-grupo-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Exame">
              <b-form-checkbox
                v-model="form.exame"
                :checked="form.exame"
                name="check-button"
                switch
                inline
                data-cy="exame-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.exame ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
          >
            <b-form-group label="Ativo">
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('combosModule', {
      comboEspecialidades: state => state.comboEspecialidades,
      comboGrupos: state => state.comboGrupos,
    }),
    ...mapState('procedimentosSettingsModule', {
      procedimento: state => state.procedimento,
    }),
    canInsert() {
      return this.verificarPermissao('ROLE_PROCEDIMENTO_INSERIR')
    },
    canEdit() {
      return this.verificarPermissao('ROLE_PROCEDIMENTO_ATUALIZAR')
    },
    canEditOrInsert() {
      if (this.form.id) {
        return this.canEdit
      }
      return this.canInsert
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Procedimento',
      required,
      form: {
        id: null,
        descricao: '',
        especialidade: { id: null },
        grupo: { id: null },
        ativo: true,
        exame: false,
      },
    }
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.procedimento))
    await this.$store.dispatch('combosModule/loadComboEspecialidades')
    await this.$store.dispatch('combosModule/loadComboGrupos')
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('procedimentosSettingsModule/reset')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('procedimentosSettingsModule/edit', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('procedimentosSettingsModule/insertNew', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        id: null,
        descricao: '',
        especialidade: { id: null },
        grupo: { id: null },
        ativo: true,
        exame: false,
      }
    },
  },
}
</script>
